import { ref } from 'vue';
import type { Ref } from 'vue';
import type {
  SectionViewControllerRuntimeHost,
  SectionViewUiController,
} from '../../types/editor';

/**
 * 剖面视图 UI 状态修订号。
 *
 * 设计说明：Viewer 不能进入 Vue 响应式链路，因此这里只记录普通数字信号。
 * 工具栏或右键入口收到 cad-core 状态事件后递增该值，使 PropertyManager
 * 重新判断独占面板是否应显示。
 */
const sectionViewUiRevision = ref(0);

/**
 * 从未知运行时对象中读取剖面视图控制器端口。
 *
 * @param renderer Viewer 或 PropertyManager 上下文传入的运行时对象。
 * @returns 剖面视图控制器；当前 Viewer 尚未接入时返回 null。
 */
export function resolveSectionViewController(renderer: unknown): SectionViewUiController | null {
  const runtime = renderer as SectionViewControllerRuntimeHost | null | undefined;
  return runtime?.sectionViewController ?? null;
}

/**
 * 读取剖面视图 UI 修订信号。
 *
 * @returns 仅包含普通数字的 Vue 引用。
 */
export function getSectionViewUiRevision(): Readonly<Ref<number>> {
  return sectionViewUiRevision;
}

/**
 * 通知 web-client 重新读取剖面视图控制器快照。
 *
 * @returns 无返回值。
 */
export function notifySectionViewUiStateChanged(): void {
  sectionViewUiRevision.value += 1;
}
